import React from 'react';
import { UserContext } from '../consts';

const withUser = WrappedComponent => props => <UserContext.Consumer>{context => <WrappedComponent {...props} {...context} />}</UserContext.Consumer>;

export default withUser;
